import { IDefaultOption } from 'components/common/select';

export interface IProgrammedAlertsRequest {
  brand?: string;
  engine?: string;
  frontTireSize?: string;
  rearTireSize?: string;
  model?: string;
  title: string;
  description: string;
  conditions?: { field: string; condition: string; value: string }[];
  alert_id?: string;
  alert_ref: string;
}

export interface IProgrammedAlertItem {
  brand?: string;
  brandDetails?: {
    asset_id: string;
    created_at: string;
    is_deleted: boolean;
    name: string;
    updated_at: string;
    _id: string;
  };
  conditions?: { field: string; condition: string; value: string }[];
  alert_ref: string;
  created_at: string;
  description: string;
  engine?: string;
  engineDetails: {
    created_at: string;
    is_deleted: boolean;
    name: string;
    updated_at: string;
    _id: string;
  };
  is_active: boolean;
  is_deleted: boolean;
  model?: string;
  modelDetails: {
    asset_id: string;
    brand_id: string;
    created_at: string;
    engine_id: string;
    is_deleted: boolean;
    name: string;
    tire_size_id: string;
    updated_at: string;
    _id: string;
  };
  frontTireSize?: string;
  frontTireSizeDetails: {
    created_at: string;
    is_deleted: boolean;
    name: string;
    updated_at: string;
    _id: string;
  };
  rearTireSize?: string;
  rearTireSizeDetails: {
    created_at: string;
    is_deleted: boolean;
    name: string;
    updated_at: string;
    _id: string;
  };
  title: string;
  updated_at: string;
  _id: string;
}

export interface ICondition {
  field: IDefaultOption | null;
  condition: IDefaultOption | null;
  value: string;
}
export interface ICreateEditOfferAndTipRequest {
  pdf_id?: string;
  title: string;
  description?: string;
  organization_ids: string[];
  brands?: string[];
  engines?: string[];
  is_email: boolean;
  is_notification: boolean;
  sent_at: string;
  type: string;
}

export interface ITipsAndOffers {
  title: string;
  organizations: IDefaultOption[];
  publishDate: string;
  is_notification: boolean;
  is_email: boolean;
  brands: IDefaultOption[];
  engines: IDefaultOption[];
  type: IDefaultOption | null;
}
export interface ITipsAndOffersErrors {
  title?: string;
  organization?: string;
  publishDate?: string;
  type?: string;
  contentText?: string;
}
export const initOfferData: ITipsAndOffers = {
  brands: [],
  engines: [],
   organizations: [],
  publishDate: '',
  is_email: true,
  is_notification: true,
  title: '',
  type: null,
};

export interface IOfferAndTipsItem {
  description: string;
  is_sent: string;
  organization_details: { _id: string; organization_name: string }[];
  sent_at: string;
  title: string;
  type: string;
  _id: string;
  is_email: boolean;
  is_notification: boolean;
}

export interface IOfferNotifyUser {
  name: string;
  surname: string;
  email: string;
  country_code: string;
  mobile_no: string;
  _id: string;
}
export interface IGetOfferAndTipsRequest {
  organization_id?: string;
  status: string[];
}
